import { SET_LANGUAGES, SET_LOCALE } from "./actions"
// import i18n from "../plugins/i18n";
import translations from "../translations";
import TranslationService from "../services/translation/TranslationService";

export default {
    state: {
        locale: localStorage.getItem("locale")||'en',
        translations:{},
        languages: []
    },
    getters: {
        translations: state => state.translations,
        locale: state => state.locale,
        languages: state => state.languages,
        homeRedirectionPath: state => "/" + state.locale
    },
    actions: {
        [SET_LOCALE]: async ({ commit }, locale) => {
            // return new Promise((resolve, reject) => {
            //     i18n.global.locale = locale;
            //     localStorage.setItem("locale", locale);

            //     commit(SET_LOCALE, locale);
            //     resolve();
            // })
            // i18n.global.locale = locale;
            let translationService = new TranslationService()
            let translations = await translationService.getTranslations(locale)
            commit(SET_LOCALE, {locale:locale,translations:translations.data});
            commit("addToTranslations",translations.data)

        }
    },
    mutations: {
        addToTranslations(state,data)
        {
            let merged = Object.assign(state.translations, data);;
            state.translations = merged
          

        },
        [SET_LOCALE]: (state, languageObject) => {

            state.locale = languageObject.locale;
            localStorage.setItem("locale", languageObject.locale);
            // state.translations = languageObject.translations;

        },
        [SET_LANGUAGES]: (state, languages) => {

            state.languages = languages;
        },

    }
};